module.exports = "<div class=\"reference-container\">\n    <ng-template ngFor let-entry [ngForOf]=\"citations\">\n        <div>{{'[' + entry.index + ']'}}:</div>\n        <div [id]=\"entry.key\" [innerHtml]=\"entry.text|sanitizeHtml\"></div>\n    </ng-template>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/output/references-table/references-table.component.html
// module id = ./src/app/components/output/references-table/references-table.component.html
// module chunks = main